import script from "./base-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-table.vue?vue&type=script&setup=true&lang=ts"

import "./base-table.vue?vue&type=style&index=0&id=75da73d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75da73d4"]])

export default __exports__